// Layer 4 (UI): polish.P9 (#657) — the GM's Value tab body (locked comp
// `metal-accounting.html` A, C's per-metal `valueTable`): the NSR total against
// budget as the primary figure, then one row per metal stream. Renders
// `valueTabView` verbatim.

import { Table, TBody, TD, TH, THead, TR } from '@/design-system';
import { Commentable } from '@/shared/comments/Commentable';
import { vizToneColor } from '@/versions/v1/modules/_viz';
import { CARD_TABLE } from '@/versions/v1/modules/downtime/DowntimeCard';
import type { ValueTabView } from './ValueTab.transform';

export function ValueTab({ value }: { value: ValueTabView | null }) {
  return (
    <Commentable name="BalancePersona">
      {value ? (
        <div data-value-tab>
          <p className="mb-2 flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
            <span data-value-total className="text-2xl font-semibold leading-tight tracking-[-0.01em] tabular-nums text-ink-primary">
              {value.total.nsr}{' '}
              <span className="text-xs font-medium tracking-normal text-muted">NSR</span>
            </span>
            <span className="text-xs tabular-nums text-muted">
              vs <span className="font-semibold text-ink-secondary">{value.total.budget}</span> budget ·{' '}
              <span
                data-value-variance
                className="font-semibold"
                style={value.total.tone === 'neutral' ? undefined : { color: vizToneColor(value.total.tone) }}
              >
                {value.total.variance}
              </span>{' '}
              · {value.total.basis}
            </span>
          </p>
          <div className={CARD_TABLE}>
            <Table wrap={false} className="tabular-nums">
              <THead>
                <TR>
                  <TH>Metal</TH>
                  <TH>Metal stream</TH>
                  <TH className="text-right">Tonnes</TH>
                  <TH className="text-right">NSR</TH>
                </TR>
              </THead>
              <TBody>
                {value.rows.map((row) => (
                  <TR key={row.id} data-value-row={row.metal}>
                    <TD className="whitespace-nowrap font-medium !text-ink-primary">{row.metal}</TD>
                    <TD className="whitespace-nowrap font-medium !text-ink-primary">{row.stream}</TD>
                    <TD className="whitespace-nowrap text-right">{row.tonnes}</TD>
                    <TD className="whitespace-nowrap text-right font-semibold !text-ink-primary">{row.nsr}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </div>
        </div>
      ) : (
        <p className="text-sm text-muted">unmeasured</p>
      )}
    </Commentable>
  );
}
